import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";

import Alert from '@mui/material/Alert';
import { Button, Divider,TextField, Grid, Typography, Box,CircularProgress } from "@mui/material"

import {getRemarkStruct, setData} from './RemarkStruct'
import { updateTextValue, handleSubmit,updateValue,updateSelectedValue} from '../../core/js/FormUtils'
import {createAPI, updateAPI, getAPI, updateEditableAPI} from './RemarkAPI';
import {CoreContext} from "../../core/context/CoreContext";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import {validMobileNumberEntry, validNameEntry, validEmailEntry} from '../../core/js/FormValidation';

import {getPathVariable} from '../../core/js/UrlUtils';
import { useSearchParams } from "react-router-dom";
import RadioForBoolean from '../../core/form/RadioForBoolean';
import MyDate from '../../core/components/MyDate';
import { useDispatch,useSelector } from 'react-redux';
import { updateRemarkObj,addRemarkObj, setShowEditForRemark} from 'store/slice/PharmaSlice';
import { setApiInProgress } from 'store/slice/HeaderSlice';
import { setMessage } from 'store/slice/HeaderSlice';
import DOMPurify from 'dompurify';



export default function RemarkEditFormImpl({onClose}){
    const dispatch = useDispatch();
    const [formValues, setFormValues] = useState(getRemarkStruct);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('Something went wrong');
    const [dataLoaded, setDataLoaded] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const {userprofileInfo} = useSelector((state) => state.headerslice);
    const {productObj} = useSelector((state) => state.pharmaslice.productDashboard);
    const {pharmaorderObj} = useSelector((state) => state.pharmaslice.pharmaorderDashboard);
    
    const {remarkDashboard} = useSelector((state)=>state.pharmaslice);
    const {selectedId} = useSelector((state) => state.pharmaslice.remarkDashboard);

    const [remarkId, setRemarkId] = useState(selectedId);
    const { businessid } = useSelector((state) => state.headerslice.userprofileInfo)
    const {itemIdBeingComment} = useSelector((state) => state.appslice.wkflow);
    

    const {apiInProgress} = useSelector((state)=>state.headerslice)
    useEffect(()=>{
    },[apiInProgress])

    useEffect(() => {
        console.log("selectedId=>"+selectedId);
        if (selectedId!==-1 ) {
            if (dataLoaded) return;
            getAPI(selectedId, loadForm);
        }
        else {
           // formValues.<<CONTEXT>>.value=searchParams.get('<<CONTEXT>>');
            setDataLoaded(true);
        }
        console.log("setitemIdBeingComment=>"+itemIdBeingComment);
        setFormValues({
            ...formValues,
            ['businessid']: {
                ...formValues['businessid'],
                value: businessid
            },
            ['title']: {
                ...formValues['title'],
                value: userprofileInfo.email
            },
            ['rolename']: {
                ...formValues['rolename'],
                value: userprofileInfo.rolename
            },
            ['itemid']: {
                ...formValues['itemid'],
                value: itemIdBeingComment!=0?itemIdBeingComment:pharmaorderObj.id
            },
        })
    },[]);

    const setNotification = (message) => {
        dispatch(setMessage(message));
    }
    const loadForm = (data)=>{
        setData(data, formValues, setFormValues);
        setDataLoaded(true);
    }
    const handleRadioChange = (name, value) => {
        setShowError(false);
        console.log(value+" == "+getRadioAPIvalue(value))
        updateValue(formValues, setFormValues, name, getRadioAPIvalue(value));
    }
    const getRadioValue = (value) => {
        if (value ) 
            return "yes"
        else 
            return "no"
    }
    const getRadioAPIvalue = (value) => {
        if (value ==="yes") 
            return true
        else 
            return false
    }
    const handleTextChange = (e) => {
        setShowError(false);
        const { name, value } = e.target;
        // Sanitize input to prevent XSS, but allow newlines
        const sanitizedValue = DOMPurify.sanitize(value, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
        updateTextValue(formValues, setFormValues, { target: { name, value: sanitizedValue } });
    }
    const handleDoubleChange = (e) => {
        setShowError(false);
        const parsed = parseFloat(e.target.value);
        if (!isNaN(parsed) && e.target.value == parsed)
         updateTextValue(formValues, setFormValues,e);
    }
    const handleNameChange = (e) =>{
        setShowError(false);
        
       if (validNameEntry(e))
        updateTextValue(formValues, setFormValues,e);
    }
    const handleMobileChange = (e) => {
        setShowError(false);
        
       if (validMobileNumberEntry(e))
            updateTextValue(formValues, setFormValues,e);
    }
    const handleEmailidChange = (e) => {
        setShowError(false);
        
       if (validEmailEntry(e))
            updateTextValue(formValues, setFormValues,e);
    }

    const createSuccessCallback = (obj) =>{
        dispatch(setApiInProgress(false));
        dispatch(addRemarkObj(obj));
        dispatch(setMessage('Remarks added successfully !!!'));
        dispatch(setShowEditForRemark(false));
        onClose();
        
    }
    const updateSuccessCallback = (obj) =>{
         dispatch(setApiInProgress(false));
        dispatch(updateRemarkObj(obj));
        dispatch(setMessage('Remarks updated successfully !!!'));
        dispatch(setShowEditForRemark(false));
        onClose();
        
    }
    const failuerCallback = (errorMsg) => {
         dispatch(setApiInProgress(false));
        setErrorMsg(errorMsg);
        setShowError(true);
    }
    const callCreateAPI = (formValues, successCallBack, failuerCallback) =>{
        dispatch(setApiInProgress(true));
        createAPI(formValues, successCallBack, failuerCallback);
    }
    const callUpdateAPI = (id,formValues, updateSuccessCallback, failuerCallback) =>{
        dispatch(setApiInProgress(true));
        updateAPI(id,formValues, updateSuccessCallback, failuerCallback);
    }
    const onSubmit=(e)=>{
        handleSubmit(e,remarkId, formValues, setFormValues, createSuccessCallback, updateSuccessCallback, failuerCallback, callCreateAPI, callUpdateAPI);
    }
    const setDate = (fieldName, value) => {
        var date = new Date(value);
        
        const day = date.getDate();
        const dayStr = day < 10 ? '0' + day : day.toString();

        const month = date.getMonth() + 1;
        const monthStr = month < 10 ? '0' + month : month.toString();
        var dateStr =date.getFullYear()+ "-" +  monthStr + "-" + dayStr + "T00:00:00.000Z";
        updateValue(formValues, setFormValues, fieldName, dateStr);
    }
    return (
        <form  noValidate onSubmit={onSubmit} >
            <Grid container direction="column" padding={.25}>
                {showError? <Alert severity="error">{errorMsg}</Alert>: ''}
                <Box sx={{ flexGrow: 1 }}>
                    <Grid item sx={{overflowY: "scroll", backgroundColor:'white',maxHeight:'58vh'}}>
                        <Grid container direction="column" padding={.25}>
                            {/* <Grid item>
                                <Typography variant='h4'>{remarkId===-1?'Add':'Edit'} Remark1 </Typography>
                                <Divider/>
                            </Grid>
                            <Grid height='25px' ></Grid> */}
                            {dataLoaded?
                                <Grid container display="flex" spacing={2} direction="row" justifyContent="space-between" alignItems="center"> 
                                                            
                            <Grid item lg={4} xs={12} sx={{display:'none'}}>
                                <TextField size="Normal"
                                    placeholder={formValues.title.placeholder}
                                    required={formValues.title.required}
                                    label={formValues.title.label}
                                    name={formValues.title.name}
                                    value={formValues.title.value}
                                    onChange={handleTextChange}
                                    error={formValues.title.error}
                                    helperText={formValues.title.error && formValues.title.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12} sx={{display:'none'}}>
                                <TextField size="Normal"
                                    placeholder={formValues.itemid.placeholder}
                                    required={formValues.itemid.required}
                                    label={formValues.itemid.label}
                                    name={formValues.itemid.name}
                                    value={formValues.itemid.value}
                                    onChange={handleTextChange}
                                    error={formValues.itemid.error}
                                    helperText={formValues.itemid.error && formValues.itemid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={12} xs={12} sx={{mt:1}}>
                                <TextField
                                    size="Normal"
                                    placeholder={formValues.remark.placeholder}
                                    required={formValues.remark.required}
                                    label={formValues.remark.label}
                                    name={formValues.remark.name}
                                    value={formValues.remark.value}
                                    onChange={handleTextChange}
                                    error={formValues.remark.error}
                                    helperText={formValues.remark.error && formValues.remark.errorMessage}
                                    sx={{width:'100%'}}
                                    multiline
                                    minRows={3}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12} sx={{display:'none'}}>
                                <TextField size="Normal"
                                    placeholder={formValues.rolename.placeholder}
                                    required={formValues.rolename.required}
                                    label={formValues.rolename.label}
                                    name={formValues.rolename.name}
                                    value={formValues.rolename.value}
                                    onChange={handleTextChange}
                                    error={formValues.rolename.error}
                                    helperText={formValues.rolename.error && formValues.rolename.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                        
                                    <Grid item lg={4} xs={12} sx={{display:'none'}}>
                                        <TextField size="Normal"
                                            placeholder={formValues.businessid.placeholder}
                                            required={formValues.businessid.required}
                                            label={formValues.businessid.label}
                                            name={formValues.businessid.name}
                                            value={formValues.businessid.value}
                                            onChange={handleTextChange}
                                            error={formValues.businessid.error}
                                            helpertext={formValues.businessid.error && formValues.businessid.errorMessage}
                                            sx={{ width: '100%',  }}
                                        />
                                    </Grid> 
                                </Grid>
                            :<></>}
                        </Grid>
                    </Grid>
                </Box>
                <Grid height='25px' ></Grid>
                <Grid padding={1}>
                    <Divider/>
                </Grid>
                <Grid container direction="row" justifyContent="flex-end"  >
                {   apiInProgress?<CircularProgress/>:
                    <>
                        <Button variant="outlined" type="submit" >{remarkId===-1?'Add':'Save'}</Button>&nbsp;&nbsp;&nbsp;
                        <Button variant="outlined" onClick={()=>onClose()}>Close</Button>
                    </>
                }
                </Grid>
            </Grid>
        </form>
    );
};